var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd"},[_c('div',{staticClass:"weui-gallery"},[_c('img',{staticClass:"weui-gallery__img",attrs:{"crossorigin":"anonymous","src":_vm.imgUrl,"id":"weui-gallery__img"}}),_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weui-gallery__tip"},[_c('p',[_vm._v("可邀请同事加入云系统，长按图片分享。")]),_c('p',[_vm._v("单击页面将关闭，后续可通过点击“我”→“邀请同事”邀请。")])])
}]

export { render, staticRenderFns }